import { Button, Kind } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { useFormModel } from '../FormModel'
import Card from './Card'
import MoneyInput from './MoneyInput'
import NextButton from './NextButton'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.maximum_discount_card'
)

type Props = {
  isOpen: boolean
  isCurrent: boolean
  onNext: () => void
}

const MaximumDiscountCard = ({ isOpen, isCurrent, onNext }: Props) => {
  const [css] = useStyletron()
  const { model, setModel } = useFormModel()
  // null = disabled; '' / numeric = enabled.
  const isEnabled = model.maximum !== null

  const toggle = () => {
    setModel({ ...model, maximum: isEnabled ? null : '' })
  }

  return (
    <Card title={t('title')} isOpen={isOpen}>
      <div className="d-flex justify-content-between align-items-center mb-s">
        <Text.BodyText4 color="grey70" tag="span">
          {t('description')}
        </Text.BodyText4>
        <Button
          kind={Kind.MINIMAL}
          onClick={toggle}
          aria-label={
            isEnabled ? t('disable_aria_label') : t('enable_aria_label')
          }
        >
          {isEnabled ? t('disable') : t('enable')}
        </Button>
      </div>
      {isEnabled && (
        <>
          <label
            htmlFor="maximum-discount-input"
            className={`d-block mb-xxs ${css({
              fontSize: '14px',
              fontWeight: 600,
              color: palette.grey90,
            })}`}
          >
            {t('amount_label')}
          </label>
          <MoneyInput
            id="maximum-discount-input"
            ariaLabel={t('input_aria_label')}
            value={model.maximum ?? ''}
            onChange={maximum => setModel({ ...model, maximum })}
          />
        </>
      )}
      {isCurrent && (
        <div className="d-flex justify-content-end mt-m">
          <NextButton onClick={onNext} />
        </div>
      )}
    </Card>
  )
}

export default MaximumDiscountCard
